import React, {useMemo} from 'react'
import {useSelectEntities} from 'redux/entities/useSelectEntities'
import {useRouteMatch} from 'react-router-dom'
import {SubDomainContext} from "./SubDomainContext";
import {organization_validateSubDomain_Api} from "../../apis";
import _ from "lodash"
import {originDomains, subDomains} from "./constSubDomain";
import {ROOT_URL} from "../../envs/_current/config";
import {organizationSchema} from "../../apis/schema";
import useAsyncWithCache from "../../modules/asyncCache/useAsyncWithCache";
import {bindQueryParam} from "../AppLocals/functions/routerHelper";
import {getResponseItem} from "../Shared";

// ─── Parse subdomain một lần ở module-level (hostname không đổi) ─────────────
const parseSubDomain = () => {
    const parts = window.location.hostname.split('.')
    const last = parts[parts.length - 1]
    const last_index = last === 'localhost' ? -1 : -2
    const subDomainString = parts.slice(0, last_index).join('.')
    return originDomains[subDomainString] ? '' : subDomainString
}

const subdomain = parseSubDomain()
const hasSubDomain = !!subdomain

// ─── Stable query object ──────────────────────────────────────────────────────
const subDomainApiQuery = hasSubDomain
    ? bindQueryParam({id: subdomain})
    : undefined

// ─── Provider khi KHÔNG có subdomain (không gọi API) ─────────────────────────
const NoDomainProvider = ({children}) => {
    const {url} = useRouteMatch()

    const contextValue = useMemo(
        () => ({
            isSubDomain: false,
            id: '',
            subDomainItem: null,
            url,
            url_domain: window.location.origin,
            url_pathname: window.location.pathname,
            diff_root: false,
            url_og_domain: ROOT_URL + window.location.pathname,
        }),
        [url]
    )

    return (
        <SubDomainContext.Provider value={contextValue}>
            {children}
        </SubDomainContext.Provider>
    )
}

// ─── Provider khi CÓ subdomain (gọi API validate) ────────────────────────────
const ActiveSubDomainProvider = ({children}) => {
    const {response} = useAsyncWithCache({
        cacheId: 'sub_domain_' + subdomain,
        apiInfo: organization_validateSubDomain_Api,
        query: subDomainApiQuery,
    })

    const cache = getResponseItem(response)
    const organization_idname = _.get(cache, 'idname') || subdomain

    const item = useSelectEntities(organization_idname, organizationSchema) || {
        sub_domain: !!subDomains[subdomain || '0'],
    }

    const {url} = useRouteMatch()

    const isActiveSub =
        !!item &&
        !!_.get(item, 'sub_domain') &&
        window.location.origin !== ROOT_URL

    const contextValue = useMemo(
        () =>
            isActiveSub
                ? {
                    isSubDomain: true,
                    id: subdomain,
                    subDomainItem: item,
                    url,
                    url_domain: window.location.origin,
                    url_pathname: window.location.pathname,
                    diff_root: true,
                    url_og_domain: ROOT_URL + window.location.pathname,
                }
                : {
                    isSubDomain: false,
                    id: subdomain,
                    subDomainItem: null,
                    url,
                    url_domain: window.location.origin,
                    url_pathname: window.location.pathname,
                    diff_root: window.location.origin !== ROOT_URL,
                    url_og_domain: ROOT_URL + window.location.pathname,
                },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [isActiveSub, url, item]
    )

    return (
        <SubDomainContext.Provider value={contextValue}>
            {children}
        </SubDomainContext.Provider>
    )
}

// ─── Root export: chọn component phù hợp tại module-level ────────────────────
const SubDomainProvider = ({children}) =>
    hasSubDomain
        ? <ActiveSubDomainProvider>{children}</ActiveSubDomainProvider>
        : <NoDomainProvider>{children}</NoDomainProvider>

export default SubDomainProvider